<template>
	<div id="app">
		<transition :name="transition">
			<router-view v-if="loaded" />
		</transition>
		<toasts />
	</div>
</template>

<script>
import Toasts from '@/components/shared/Toasts'

export default {
	name: 'Protoswipe',
	data() {
		return {
			loaded: false,
			transition: undefined
		}
	},
	computed: {
		lockScroll() {
			return this.$store.getters['modals/anyOpen']
		}
	},
	methods: {
		setTitle(route = this.$route) {
			const base = (route.meta && route.meta.baseTitle) || 'okHiQ'
			document.title = `${route.name} | ${base}`
		},
		setTransition(to, from) {
			if (to.meta.overlay && !from.meta.overlay) {
				this.transition = 'overlay-in'
			} else if (!to.meta.overlay && from.meta.overlay) {
				this.transition = 'overlay-out'
			} else {
				this.transition = undefined
			}
		}
	},
	watch: {
		$route(to, from) {
			this.setTitle(to)
			this.setTransition(to, from)
		},
		lockScroll(lock) {
			if (lock) document.body.classList.add('lock-scroll')
			else document.body.classList.remove('lock-scroll')
		}
	},
	async created() {
		// Set page title
		this.setTitle(this.$route)

		// Load global config and logged-in user
		await this.$store.dispatch('config/get')
		this.loaded = true

		// Wait for captcha
		await this.$recaptchaLoaded()
	},
	components: {
		Toasts
	}
}
</script>

<style lang="scss">
@import '~scss/base';

body.lock-scroll {
	overflow: hidden;
}
</style>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/transitions';
@include overlay($spd-page);
</style>
